import { AcesoTvDeviceData, EventBase } from "@vp/models";

export interface AcesoStatusChangedEventArgs {
  deviceUserId: string;
  acesoTvDeviceData: AcesoTvDeviceData;
  isOnline: boolean;
}

export class AcesoStatusChangedEvent extends EventBase<AcesoStatusChangedEventArgs> {
  constructor(statusChangedArgs: AcesoStatusChangedEventArgs) {
    super();
    this.args = statusChangedArgs;
  }
}
